import { FASTElement as a } from "@microsoft/fast-element";
import { hintStyles as r } from "./hint.styles.js";
import { hintTemplate as n } from "./hint.template.js";
import { applyMixins as e } from "../common/apply-mixins.js";
import { HintMixin as o } from "./hint-mixin.js";
const i = class i extends a {
  constructor() {
    super(...arguments), this.variantIconMap = {
      neutral: "information-circle",
      warning: "exclamation-circle",
      error: "exclamation-triangle",
      highlight: "information-circle"
    };
  }
  get iconName() {
    return this.variantIconMap[this.variant];
  }
  connectedCallback() {
    super.connectedCallback(), this.variant || (this.variant = "neutral");
  }
};
i.definition = {
  name: "hint",
  template: n,
  styles: () => r,
  attributes: ["variant"]
};
let t = i;
e(t, o);
export {
  t as Hint
};
